import { DateTime } from "luxon"

export type MerchantNewsArticle = NormalMerchantNewsArticle | ExternalMerchantNewsArticle | MerchantProductNewsArticle

export type LeadImage = Readonly<{
    url: string
    uid?: string
}>
export type BaseMerchantNewsArticle = Readonly<{
    id: number
    type: MerchantArticleType
    status: MerchantArticleStatus
    subject: string
    imageUrl?: string | null
    leadImage?: LeadImage
    created?: string
    updated?: string
    publishDate?: string
    expirationDate?: string
}>

export type NormalMerchantNewsArticle = BaseMerchantNewsArticle &
    Readonly<{
        type: MerchantArticleType.NORMAL_ARTICLE
        body?: string
    }>

export type ExternalMerchantNewsArticle = BaseMerchantNewsArticle &
    Readonly<{
        type: MerchantArticleType.EXTERNAL_ARTICLE
        permaLink?: string
    }>

export type MerchantProductNewsArticle = BaseMerchantNewsArticle &
    Readonly<{
        type: MerchantArticleType.PRODUCT_NEWS
        productId?: string
        body?: string
    }>

export enum MerchantArticleType {
    NORMAL_ARTICLE = "NORMAL_ARTICLE",
    EXTERNAL_ARTICLE = "EXTERNAL_ARTICLE",
    PRODUCT_NEWS = "PRODUCT_NEWS",
}

export enum MerchantArticleStatus {
    DRAFT = "DRAFT",
    PUBLISHED = "PUBLISHED",
    SCHEDULED = "SCHEDULED",
    EXPIRED = "EXPIRED",
}

export type CreateOrEditArticleFormValues = Readonly<{
    subject: string
    type: MerchantArticleType
    status: MerchantArticleStatus
    body?: string
    leadImage?: LeadImage
    product?: {
        id: number
    }
    productId?: number
    permaLink?: string
    publishDate?: DateTime
    expirationDate?: DateTime
}>
export type ArticleItem = Readonly<{
    subject: string
    type: MerchantArticleType
    status: MerchantArticleStatus
    body?: string
    leadImage?: LeadImage
    product?: {
        id: number
    }
    productId?: number
    permaLink?: string
    publishDate?: string
    expirationDate?: string
}>
